var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPARKINGAPP = CONFUSEDPARKINGAPP || {},
    Confused = Confused || {};
CONFUSEDPARKINGAPP.Map = CONFUSEDPARKINGAPP.Map || {};

(function (ns, $) {
    'use strict';

    // html elements
    ns.Elements = {
        ParkingAppMap: '#parkingAppMap',
        ParkingAppSpace: '.node-parking-space',
        ParkingAppMapClickthroughAvailable: '#hdnParkingAppMapClickthroughAvailable',
        ParkingAppMapClickthroughUnavailable: '#hdnParkingAppMapClickthroughUnavailable'
    };

    // tokens
    ns.Tokens = {
        ParkingSpaceListNumber: '.token-parking-space-list-number',
        ParkingSpaceTitle: '.token-parking-space-title',
        ParkingSpaceDescription: '.token-parking-space-description',
        ParkingSpaceDistance: '.token-parking-space-distance',
        ParkingSpacePriceHourly: '.token-parking-space-price-hourly',
        ParkingSpacePriceDaily: '.token-parking-space-price-daily',
        ParkingSpacePriceMonthly: '.token-parking-space-price-monthly',
        ParkingSpaceFeature: '.token-parking-space-feature',
        ParkingSpaceReviewsAverage: '.token-parking-space-reviews-average',
        ParkingSpaceMapMarkerIcon: '.token-parking-space-map-marker-icon',
        ParkingSpaceClickthrough: '.token-parking-space-clickthrough',
        ParkingSpaceImageSpaceCurrentlyUnavailable: '.token-parking-space-image-space-currently-unavailable',
        ParkingSpaceImagePlaceholderWrapper: '.token-parking-space-image-placeholder-wrapper'
    };

    // nodes
    ns.Nodes = {
        ParkingSpacePriceHourly: '.node-parking-space-price-hourly',
        ParkingSpacePriceDaily: '.node-parking-space-price-daily',
        ParkingSpacePriceMonthly: '.node-parking-space-price-monthly',
        ParkingSpaceFeature: '.node-parking-space-feature',
        ParkingSpaceImage: '.node-parking-space-image'
    };

    // classes
    ns.Classes = {
        ParkingSpaceImage: 'parking-space-image',
        ResultsMainCtaMoreDetails: 'result-main-cta--more-details',
        ResultsMainCtaJoinList: 'result-main-cta--join-list',
        ItemLozengeNumbered: 'item-lozenge--numbered',
        ItemLozengeLet: 'item-lozenge--let'
    };

    // constants
    ns.Constants = {
        SourceMapPanelSpacesAvailable: 'MapPanel:SpacesAvailable',
        SourceMapPanelSpacesUnavailable: 'MapPanel:SpacesUnavailable'
    };

    // initialise map
    ns.initMap = function () {

        // add map
        var options = {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            zoomControlOptions: {
              position: google.maps.ControlPosition.RIGHT_TOP
            },
            scrollwheel: false,
            disableDefaultUI: true
        };
        CONFUSEDPARKINGAPP.Utils.WriteNewRelicPageEvent('MapInit');

        var map = new google.maps.Map($(ns.Elements.ParkingAppMap).get(0), options);

        // return map
        return map;
    };

    // add parking spaces to map
    ns.addParkingSpacesToMap = function (parkingSpaces, map, markers, clickthroughData) {
        var self = this;
        self.ActiveInfoWindow = null;

        //clear existing markers
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];

        // obtain parking space template markup
        var parkingSpaceTemplate = $(ns.Elements.ParkingAppSpace);

        // obtain marker icon url
        var markerIconUrlObj = $(parkingSpaceTemplate).find(ns.Tokens.ParkingSpaceMapMarkerIcon).css('background-image');
        var markerIconUrl = markerIconUrlObj.replace('url(', '').replace(')', '').replace(/\"/gi, '');

        // create map bounds
        var bounds = new google.maps.LatLngBounds();

        // add marker and info-window for each parking space
        $.each(parkingSpaces, function (index, space) {

            // continue looping if space not enabled
            if (space.Enabled() === false) {
                return;
            }

            // offset lat/lng
            ns.offsetLatLng(space, parkingSpaces);

            // create marker and info-window
            var labelText = space.ListNumber().toString();
            var marker = new google.maps.Marker({
                map: map,
                anchorPoint: new google.maps.Point(0, -29),
                label: {
                    text: ' ',
                    fontFamily: 'Roboto, Arial, sans-serif, custom-marker-label-' + labelText
                }
            });

            var infowindow = new google.maps.InfoWindow();

            // set marker
            var originX = 30;
            if (!space.SpacesAvailable()) {
                originX = 96;
            }

            marker.setIcon({
                url: markerIconUrl,
                size: new google.maps.Size(46, 40),
                origin: new google.maps.Point(originX, 165),
                anchor: new google.maps.Point(17, 34),
                scaledSize: new google.maps.Size(168, 206)
            });

            marker.setPosition({ lat: space.Location().Lat, lng: space.Location().Lng });
            marker.setVisible(true);

            // set info-window content
            var infoContent = ns.getInfoContent(parkingSpaceTemplate.clone(), space, clickthroughData);
            infowindow.setContent(infoContent[0]);

            // add listener to marker
            marker.addListener('click', function () {
                if (self.ActiveInfoWindow !== null) {
                    self.ActiveInfoWindow.close();
                }

                infowindow.open(map, marker);
                self.ActiveInfoWindow = infowindow;
            });

            // add marker to bounds
            bounds.extend(marker.getPosition());

            // add marker to markers
            markers.push(marker);
        });

        // add events for multi-character marker icon label text
        ns.addMarkerIconLabelTextEvents(map, parkingSpaceTemplate);

        // fit bounds for map
        setTimeout(function () {
            map.fitBounds(bounds);
        }, 50);

        // return markers
        return markers;
    };

    // get info content
    ns.getInfoContent = function (template, space, clickthroughData) {
        var infoContent = template;

        // handle info
        $(infoContent).find(ns.Tokens.ParkingSpaceTitle).text(space.Title());
        $(infoContent).find(ns.Tokens.ParkingSpaceDescription).text(space.Description());
        $(infoContent).find(ns.Tokens.ParkingSpaceDistance).text(space.Distance());

        // handle list number
        $(infoContent).find(ns.Tokens.ParkingSpaceListNumber).text(space.ListNumber());

        if (space.SpacesAvailable()) {
            $(infoContent).find(ns.Tokens.ParkingSpaceListNumber).addClass(ns.Classes.ItemLozengeNumbered);
        } else {
            $(infoContent).find(ns.Tokens.ParkingSpaceListNumber).addClass(ns.Classes.ItemLozengeLet);
        }

        // handle image info
        if (space.ImageUrl()) {
            $(infoContent).find(ns.Nodes.ParkingSpaceImage).append('<img src=\'' + space.ImageUrl() + '\' class=\'' + ns.Classes.ParkingSpaceImage + '\'>');
        } else {
            $(infoContent).find(ns.Tokens.ParkingSpaceImagePlaceholderWrapper).show();
        }

        if (!space.SpacesAvailable()) {
            $(infoContent).find(ns.Tokens.ParkingSpaceImageSpaceCurrentlyUnavailable).show();
        }

        // handle prices info
        ns.bindPriceInfoContent(infoContent, space.PriceHourly(), ns.Tokens.ParkingSpacePriceHourly, ns.Nodes.ParkingSpacePriceHourly);
        ns.bindPriceInfoContent(infoContent, space.PriceDaily(), ns.Tokens.ParkingSpacePriceDaily, ns.Nodes.ParkingSpacePriceDaily);
        ns.bindPriceInfoContent(infoContent, space.PriceMonthly(), ns.Tokens.ParkingSpacePriceMonthly, ns.Nodes.ParkingSpacePriceMonthly);

        // handle review average info
        if (space.ReviewsAverageClass() === null) {
            $(infoContent).find(ns.Tokens.ParkingSpaceReviewsAverage).css('background-image', 'none');
        } else {
            $(infoContent).find(ns.Tokens.ParkingSpaceReviewsAverage).addClass(space.ReviewsAverageClass());
        }

        // handle clickthrough buttons
        if (space.SpacesAvailable()) {

            $(infoContent).find(ns.Tokens.ParkingSpaceClickthrough).click(function () {
                ns.handleMapClickthrough(space.ClickthroughUrl(), space.Id(), space.PriceHourly(), space.PriceDaily(), space.PriceMonthly(), space.Distance(), ns.Constants.SourceMapPanelSpacesAvailable, clickthroughData);
            });

            $(infoContent).find(ns.Tokens.ParkingSpaceClickthrough).html($(ns.Elements.ParkingAppMapClickthroughAvailable).val());
            $(infoContent).find(ns.Tokens.ParkingSpaceClickthrough).addClass(ns.Classes.ResultsMainCtaMoreDetails);

        } else {

            $(infoContent).find(ns.Tokens.ParkingSpaceClickthrough).click(function () {
                ns.handleMapClickthrough(space.ClickthroughUrl(), space.Id(), space.PriceHourly(), space.PriceDaily(), space.PriceMonthly(), space.Distance(), ns.Constants.SourceMapPanelSpacesUnavailable, clickthroughData);
            });

            $(infoContent).find(ns.Tokens.ParkingSpaceClickthrough).html($(ns.Elements.ParkingAppMapClickthroughUnavailable).val());
            $(infoContent).find(ns.Tokens.ParkingSpaceClickthrough).addClass(ns.Classes.ResultsMainCtaJoinList);
        }

        return infoContent;
    };

    // bind price info content
    ns.bindPriceInfoContent = function (infoContent, price, token, node) {
        if (price > 0) {
            $(infoContent).find(token).text(price);
        } else {
            $(infoContent).find(node).remove();
        }
    };

    // handle map clickthrough
    ns.handleMapClickthrough = function (clickthroughUrl, id, priceHourly, priceDaily, priceMonthly, distance, source, clickthroughData) {

        //log mi
        CONFUSEDPARKINGAPP.submitClickthrough(clickthroughUrl, id, priceHourly, priceDaily, priceMonthly, distance, source);

        // create parking search cookie
        var cookieValue = clickthroughData.LocationLatitude + clickthroughData.CookieDelimiter +
            clickthroughData.LocationLongitude + clickthroughData.CookieDelimiter +
            clickthroughData.SearchAddress + clickthroughData.CookieDelimiter +
            clickthroughData.PlaceId;

        Confused.CookieManager.prototype.setItem(clickthroughData.ParkingSearchCookieName, cookieValue, null, '/', clickthroughData.CookieDomain);

        // redirect to clickthrough url
        setTimeout(function () {
            window.open(clickthroughUrl, '_self');
        }, 50);
    };

    // offset latitude longitude
    ns.offsetLatLng = function (space, parkingSpaces) {
        var offset = 0.000050;

        while (ns.isDuplicateLatLng(space.Id(), space.Location().Lat, space.Location().Lng, parkingSpaces)) {
            space.Location().Lat += offset;
            space.Location().Lng += offset;
        }
    };

    // is duplicate latitude longitude
    ns.isDuplicateLatLng = function (id, lat, lng, parkingSpaces) {
        var isDuplicateLatLng = false;

        $.each(parkingSpaces, function (index, space) {
            if (space.Id() !== id &&
                space.Location().Lat === lat &&
                space.Location().Lng === lng) {
                isDuplicateLatLng = true;
                return false;
            }
        });

        return isDuplicateLatLng;
    };

    // add marker icon label text events
    ns.addMarkerIconLabelTextEvents = function (map, parkingSpaceTemplate) {

        google.maps.event.addListener(map, 'idle', function () {
            ns.addMarkerIconLabelText(map, parkingSpaceTemplate);
        });

        ns.addTilesAndZoomEvents(map, parkingSpaceTemplate, 50);
        ns.addTilesAndZoomEvents(map, parkingSpaceTemplate, 100);
    };

    // add tiles and zoom events
    ns.addTilesAndZoomEvents = function (map, parkingSpaceTemplate, timeout) {

        google.maps.event.addListener(map, 'tilesloaded', function () {
            setTimeout(function () {
                ns.addMarkerIconLabelText(map, parkingSpaceTemplate);
            }, timeout);
        });

        google.maps.event.addListener(map, 'zoom_changed', function () {
            setTimeout(function () {
                ns.addMarkerIconLabelText(map, parkingSpaceTemplate);
            }, timeout);
        });
    };

    // add marker icon label text
    ns.addMarkerIconLabelText = function (map, parkingSpaceTemplate) {
        var labels = document.querySelectorAll('[style*=\'custom-marker-label\']');
        var labelHtml = $($(parkingSpaceTemplate).find(ns.Tokens.ParkingSpaceMapMarkerIcon)[0].innerHTML);

        for (var i = 0; i < labels.length; i++) {
            var matches = labels[i].getAttribute('style').match(/custom-marker-label-([0-9]+)/);

            $(labelHtml).html(matches[1]);
            labels[i].innerHTML = labelHtml.get(0).outerHTML;
        }
    };

}(CONFUSEDPARKINGAPP.Map, jQuery));